import {KIND} from 'baseui/toast'
import {setLoading} from './app-slice'
import {db} from './firebase'
import {setNotification} from './notification-slice'

export const updateUserData = (update, uid) => async dispatch => {
  dispatch(setLoading({setLoading: true}))
  try {
    await db
      .collection('users')
      .doc(uid)
      .set({...update}, {merge: true})
    dispatch(setLoading({setLoading: false}))
  } catch (error) {
    dispatch(setNotification({code: error.code, message: error.message, kind: KIND.negative}))
    dispatch(setLoading({setLoading: false}))
  }
}
